export const normalizeGenre = (genre) => (genre === 'Podcasts' ? 'Top Podcasts' : genre);
